import { Outlet } from "react-router-dom";

export default function AdminLayout() {
    return (
        <div style={{ padding: 16, maxWidth: 1080, margin: "0 auto" }}>
            <Outlet />
        </div>
    );
}
